import React, { useEffect } from 'react';
import { CouponsGrid } from './CouponsGrid';
import { coupons as testIds } from '../../shared/TestsIds';
import { useData } from '../../../data-layer';

export function Coupons(): React.ReactElement {
  const { coupons, plans } = useData();

  // Plans back the PlanBadge the grid renders for each coupon's plans.
  useEffect(() => {
    coupons.hook.getAll();
    plans.hook.getAll();
  }, []);

  return <CouponsGrid data-testid={testIds.root} />;
}
